const STORAGE_KEY = 'imagoMpApiEndpoint';

export const API_ENDPOINTS = {
    CI: {
        NAME: 'CI',
        URL: 'https://imago-ci.api.dev-sqnt.com/',
        COLOUR: 'green',
    },
    DEV1: {
        NAME: 'Dev 1',
        URL: 'https://imago-dev1.api.dev-sqnt.com/',
        COLOUR: 'blue',
    },
    DEV2: {
        NAME: 'Dev 2',
        URL: 'https://imago-dev2.api.dev-sqnt.com/',
        COLOUR: 'blue',
    },
    DEV3: {
        NAME: 'Dev 3',
        URL: 'https://imago-dev3.api.dev-sqnt.com/',
        COLOUR: 'blue',
    },
    DEV4: {
        NAME: 'Dev 4',
        URL: 'https://imago-dev4.api.dev-sqnt.com/',
        COLOUR: 'blue',
    },
    EVO1: {
        NAME: 'Evo Hub 1',
        URL: 'https://imago-evo1.api.dev.dev-sqnt.com/',
        COLOUR: 'black',
    },
    LOCAL: {
        NAME: 'Local',
        URL: 'http://localhost:3000/',
        COLOUR: 'purple',
    },
    // Some complications with enabling prod right now. Leaving it commented out as a warning.
    //
    // PROD: {
    //     NAME: 'PROD',
    //     URL: 'https://imago.api.seequent.com/',
    //     COLOUR: 'red',
    // },
};

export const setApiEndpoint = (key: keyof typeof API_ENDPOINTS) => {
    const apiEndpoint = API_ENDPOINTS[key];
    if (!apiEndpoint) {
        alert(`API endpoint ${key} does not exist.`);
        return;
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(apiEndpoint));

    alert(
        'API endpoint has changed. The application will now reload and you may need to log in again.',
    );
    window.location.reload();
};

export const getApiEndpoint = (): (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS] => {
    const storedEndpoint = sessionStorage.getItem(STORAGE_KEY);
    if (storedEndpoint) {
        try {
            const endpoint = JSON.parse(storedEndpoint) as
                Partial<(typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS]> | null | undefined;
            if (
                endpoint &&
                typeof endpoint === 'object' &&
                'NAME' in endpoint &&
                'URL' in endpoint
            ) {
                return endpoint as (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS];
            }
        } catch (e) {
            console.error('Failed to parse stored API endpoint:', e);
        }
    }

    return API_ENDPOINTS.CI; // Default to CI if no valid endpoint is found
};
